/**
 * Status do registro histórico de plano ou permissão
 */
export enum StatusHistorico {
  /** Aguardando pagamento */
  PENDENTE_PAGAMENTO = 'PENDENTE_PAGAMENTO',
  /** Pagamento em processamento (PIX, boleto) */
  PROCESSANDO = 'PROCESSANDO',
  /** Registro ativo no momento */
  ATIVO = 'ATIVO',
  /** Pagamento atrasado/falhou - acesso suspenso */
  SUSPENSO = 'SUSPENSO',
  /** Registro expirado por prazo */
  EXPIRADO = 'EXPIRADO',
  /** Registro cancelado manualmente */
  CANCELADO = 'CANCELADO',
}
